import {
    GiLotus,
    GiFeather,
    GiPeaceDove,
    GiHearts,
    GiDiscussion,
    GiMeditation,
    GiStarsStack,
  } from "react-icons/gi";
  
  const ChakraIntro = () => {
    const chakras = [
      {
        name: "1. Mooladhara",
        quality: "Innocence, Purity, Wisdom",
        affirmation: "I am pure, innocent and fearless.",
        icon: <GiLotus className="text-red-500 text-3xl" />,
      },
      {
        name: "2. Swadhisthana",
        quality: "Creativity, Pure Knowledge",
        affirmation: "I am the source of pure knowledge and creativity.",
        icon: <GiFeather className="text-yellow-500 text-3xl" />,
      },
      {
        name: "3. Nabhi",
        quality: "Peace, Satisfaction, Generosity",
        affirmation: "I am completely content and at peace within myself.",
        icon: <GiPeaceDove className="text-green-500 text-3xl" />,
      },
      {
        name: "4. Anahata",
        quality: "Love, Compassion, Security",
        affirmation: "I am the spirit. I am love and compassion.",
        icon: <GiHearts className="text-pink-500 text-3xl" />,
      },
      {
        name: "5. Vishuddhi",
        quality: "Communication, Diplomacy, Respect",
        affirmation: "I am not guilty. I am part and parcel of the whole.",
        icon: <GiDiscussion className="text-blue-500 text-3xl" />,
      },
      {
        name: "6. Agnya",
        quality: "Forgiveness, Humility, Thoughtless Awareness",
        affirmation: "I forgive everyone and I forgive myself.",
        icon: <GiMeditation className="text-indigo-500 text-3xl" />,
      },
      {
        name: "7. Sahasrara",
        quality: "Integration, Connection with Divine",
        affirmation: "I am one with the Divine. I am in thoughtless awareness.",
        icon: <GiStarsStack className="text-purple-500 text-3xl" />,
      },
    ];
  
    return (
      <section className="bg-gray-50 py-20 px-4 sm:px-6 lg:px-16">
        {/* Intro Section */}
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div data-aos="fade-right">
            <img
              src="/Websote-Photos-12.png"
              alt="Subtle System - Sahaja Yoga Chakras"
              className="w-full h-auto rounded-xl shadow-md border border-green-100"
            />
          </div>
  
          <div data-aos="fade-left">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4 leading-snug">
              Chakras
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              There are seven main chakras (energy centers) located along the spine. They are the
              fulcrums that control most aspects of our physical, mental, and spiritual lives.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              Chakras are connected by channels (nadis). When the Kundalini rises and nourishes
              the chakras, our body automatically becomes dynamic, creative, and integrated.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Each chakra governs a part of your nervous system and holds specific spiritual qualities
              that shape your personality and inner balance.
            </p>
          </div>
        </div>
  
        {/* Chakra Cards */}
        <div className="max-w-6xl mx-auto mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 gap-y-10">
          {chakras.map((chakra, index) => (
            <div
              key={index}
              className="bg-white border border-gray-100 rounded-2xl p-6 shadow hover:shadow-md transition text-center"
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className="mb-4 flex justify-center">{chakra.icon}</div>
              <h3 className="text-lg font-semibold text-gray-800 mb-1">{chakra.name}</h3>
              <p className="text-sm text-gray-600 mb-2">{chakra.quality}</p>
              <p className="text-sm italic text-green-700">“{chakra.affirmation}”</p>
            </div>
          ))}
        </div>
      </section>
    );
  };
  
  export default ChakraIntro;
  